/* PH24 Quiz — drives sections/ph24-quiz-page.liquid.
   Config (questions, options, product data) is emitted by Liquid into a
   <script type="application/json" data-qz-config> island, so everything the
   merchant edits in the theme editor flows straight through to here. */

(function () {
  'use strict';

  const root = document.querySelector('[data-qz-root]');
  if (!root) return;

  const configEl = root.querySelector('[data-qz-config]');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (err) {
    console.error('[PH24 Quiz] Nieprawidłowa konfiguracja:', err);
    return;
  }

  const questions = (config.questions || []).filter(q => q.options && q.options.length);
  if (!questions.length) return;

  const labels = config.labels || {};
  const maxResults = config.maxResults || 6;

  /* ── DOM refs ───────────────────────────────────────────── */

  const screens = {
    intro:     root.querySelector('[data-qz-screen="intro"]'),
    questions: root.querySelector('[data-qz-screen="questions"]'),
    results:   root.querySelector('[data-qz-screen="results"]')
  };
  const els = {
    consent:    root.querySelector('#qz-consent'),
    start:      root.querySelector('[data-qz-start]'),
    progress:   root.querySelector('[data-qz-progress]'),
    stepLabel:  root.querySelector('[data-qz-step-label]'),
    question:   root.querySelector('[data-qz-question]'),
    hint:       root.querySelector('[data-qz-hint]'),
    options:    root.querySelector('[data-qz-options]'),
    back:       root.querySelector('[data-qz-back]'),
    next:       root.querySelector('[data-qz-next]'),
    results:    root.querySelector('[data-qz-results]'),
    warnings:   root.querySelector('[data-qz-warnings]'),
    empty:      root.querySelector('[data-qz-empty]'),
    restart:    root.querySelector('[data-qz-restart]'),
    sticky:     root.querySelector('[data-qz-sticky]'),
    stickyCount:root.querySelector('[data-qz-sticky-count]'),
    stickyTotal:root.querySelector('[data-qz-sticky-total]'),
    /* Pasek przy liście dopasowań — ten sam zestaw, drugie miejsce na CTA. */
    bulk:       root.querySelector('[data-qz-bulk]'),
    bulkCount:  root.querySelector('[data-qz-bulk-count]'),
    bulkTotal:  root.querySelector('[data-qz-bulk-total]'),
    /* Przycisków „dodaj” jest teraz dwa: przy liście i w przypiętym pasku. */
    addButtons: [...root.querySelectorAll('[data-qz-add]')]
  };

  /* ── State ──────────────────────────────────────────────── */

  let stepIndex = 0;
  const answers = questions.map(() => new Set());
  let recommended = [];
  const chosen = new Set();

  /* ── Helpers ────────────────────────────────────────────── */

  const money = cents => (cents / 100)
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' zł';

  // Polish plurals: 1 produkt / 2-4 produkty / 5+ produktów (with the
  // 12-14 exception, which always takes the "many" form).
  function plural(n) {
    const one  = labels.productsOne  || 'produkt';
    const few  = labels.productsFew  || 'produkty';
    const many = labels.productsMany || 'produktów';
    if (n === 1) return one;
    const last2 = n % 100;
    const last1 = n % 10;
    if (last2 >= 12 && last2 <= 14) return many;
    return (last1 >= 2 && last1 <= 4) ? few : many;
  }

  const fill = (tpl, ...vals) => {
    let i = 0;
    return String(tpl || '').replace(/%s/g, () => (i < vals.length ? vals[i++] : ''));
  };

  function show(name) {
    Object.keys(screens).forEach(key => {
      if (screens[key]) screens[key].hidden = key !== name;
    });
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── Deep link: /pages/quiz?potrzeba=<option label or key> ── */

  function applyDeepLink() {
    const param = new URLSearchParams(window.location.search).get('potrzeba');
    if (!param) return false;
    const needle = param.trim().toLowerCase();

    for (let qi = 0; qi < questions.length; qi++) {
      const q = questions[qi];
      const oi = q.options.findIndex(o =>
        o.label.toLowerCase().includes(needle) ||
        (q.key || '').toLowerCase() === needle
      );
      if (oi > -1) {
        answers[qi].add(oi);
        return true;
      }
    }
    return false;
  }

  /* ── Areas ──────────────────────────────────────────────────
     An option can name a collection ("area"). Answering activates it, and a
     question flagged filterByArea then shows only the options belonging to an
     activated area — so picking "Trawienie" leads to digestive symptoms, and
     picking several areas gives a mixed list. */

  function activeAreas(uptoStep) {
    const set = new Set();
    questions.forEach((q, qi) => {
      if (uptoStep != null && qi >= uptoStep) return;
      answers[qi].forEach(oi => {
        const a = q.options[oi] && q.options[oi].area;
        if (a) set.add(a);
      });
    });
    return set;
  }

  // Options actually shown for a step, with their original indexes preserved.
  function visibleOptions(qi) {
    const q = questions[qi];
    const all = q.options.map((opt, oi) => ({ opt, oi }));
    if (!q.filterByArea) return all;

    const areas = activeAreas(qi);
    if (!areas.size) return all;

    const matching = all.filter(({ opt }) => !opt.area || areas.has(opt.area));
    // Never strand the visitor on an empty question.
    return matching.length ? matching : all;
  }

  /* ── Question rendering ─────────────────────────────────── */

  /* Krok, na którym została jedna opcja, nie jest pytaniem — nie ma z czego
     wybierać. Takie kroki pomijamy, więc numeracja musi liczyć tylko te,
     które odwiedzający realnie zobaczy. */
  function isSkippable(qi) {
    return visibleOptions(qi).length === 1;
  }

  function stepNumbers() {
    let shown = 0, position = 0;
    for (let i = 0; i < questions.length; i++) {
      if (isSkippable(i)) continue;
      shown++;
      if (i === stepIndex) position = shown;
    }
    return { position: position || 1, total: shown || 1 };
  }

  function renderStep() {
    const q = questions[stepIndex];
    const selected = answers[stepIndex];
    const num = stepNumbers();

    els.question.textContent = q.title;
    els.stepLabel.textContent = fill(labels.step, num.position, num.total);
    els.progress.style.width = ((num.position / num.total) * 100) + '%';

    if (q.multi && labels.multiHint) {
      els.hint.textContent = labels.multiHint;
      els.hint.hidden = false;
    } else {
      els.hint.hidden = true;
    }

    els.options.innerHTML = '';
    visibleOptions(stepIndex).forEach(({ opt, oi }) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qz-option' + (selected.has(oi) ? ' selected' : '');
      btn.setAttribute('role', q.multi ? 'checkbox' : 'radio');
      btn.setAttribute('aria-checked', String(selected.has(oi)));

      const mark = document.createElement('span');
      mark.className = 'qz-option-mark' + (q.multi ? '' : ' round');
      const text = document.createElement('span');
      text.className = 'qz-option-text';
      text.textContent = opt.label;
      btn.append(mark, text);

      btn.addEventListener('click', () => {
        if (q.multi) {
          selected.has(oi) ? selected.delete(oi) : selected.add(oi);
        } else {
          selected.clear();
          selected.add(oi);
        }
        renderStep();
        if (!q.multi) window.setTimeout(goNext, 180);
      });

      els.options.appendChild(btn);
    });

    /* „Wstecz” i etykieta ostatniego pytania liczą się względem kroków
       faktycznie pokazywanych, a nie indeksu w konfiguracji — po pominięciu
       pytania stepIndex przestaje się z nimi pokrywać. */
    let hasPrev = false;
    for (let i = 0; i < stepIndex; i++) if (!isSkippable(i)) { hasPrev = true; break; }

    let hasNext = false;
    for (let i = stepIndex + 1; i < questions.length; i++) if (!isSkippable(i)) { hasNext = true; break; }

    els.back.hidden = !hasPrev;
    els.next.disabled = !q.optional && selected.size === 0;
    if (!hasNext && els.next.dataset.finalLabel) els.next.textContent = els.next.dataset.finalLabel;
  }

  /* Przechodzi o jeden krok w zadanym kierunku, przeskakując pytania,
     w których po filtrowaniu została jedna opcja. Odpowiedź na pominięty
     krok zaznaczamy automatycznie — to jedyna możliwa, więc wynik quizu
     jest taki sam, jakby odwiedzający kliknął ją sam. */
  function move(direction) {
    let i = stepIndex;

    for (;;) {
      i += direction;

      if (i < 0) return;
      if (i > questions.length - 1) {
        show('results');
        buildResults();
        return;
      }

      if (!isSkippable(i)) break;

      const only = visibleOptions(i)[0];
      answers[i].clear();
      answers[i].add(only.oi);
    }

    stepIndex = i;
    renderStep();
  }

  function goNext() {
    const q = questions[stepIndex];
    if (!q.optional && answers[stepIndex].size === 0) return;
    move(1);
  }

  function goBack() {
    if (stepIndex === 0) return;
    move(-1);
  }

  /* ── Scoring ────────────────────────────────────────────── */

  // Collections are read live from the storefront, so a product added to a
  // collection shows up in the quiz without touching the theme editor.
  const collectionCache = new Map();

  async function fetchCollection(handle) {
    if (collectionCache.has(handle)) return collectionCache.get(handle);
    const req = fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`)
      .then(r => (r.ok ? r.json() : { products: [] }))
      .then(d => (d.products || []).map(p => {
        const v = (p.variants || []).find(x => x.available) || p.variants[0];
        if (!v) return null;
        return {
          variantId: String(v.id),
          handle: p.handle,
          title: p.title,
          vendor: p.vendor,
          url: `/products/${p.handle}`,
          available: !!v.available,
          price: Math.round(parseFloat(v.price) * 100),
          compareAt: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
          image: p.images && p.images[0] ? p.images[0].src : ''
        };
      }).filter(Boolean))
      .catch(() => []);
    collectionCache.set(handle, req);
    return req;
  }

  // Fisher-Yates, so every product in a collection has an equal chance.
  function shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  async function buildResults() {
    const byVariant = new Map();
    const warnings = [];
    const pending = [];

    const addProduct = (p, opt, weight) => {
      if (!p.variantId || !p.available) return;
      const existing = byVariant.get(p.variantId);
      if (existing) {
        // Suggested by several answers = a stronger match.
        existing.score += weight;
        if (!existing.reason && opt.reason) existing.reason = opt.reason;
      } else {
        byVariant.set(p.variantId, Object.assign({}, p, {
          score: weight,
          reason: opt.reason || '',
          order: byVariant.size
        }));
      }
    };

    questions.forEach((q, qi) => {
      answers[qi].forEach(oi => {
        const opt = q.options[oi];
        if (!opt) return;
        if (opt.warning) warnings.push(opt.warning);

        // A hand-picked list wins over the collection for that answer.
        if (opt.products && opt.products.length) {
          opt.products.forEach(p => addProduct(p, opt, 2));
        } else if (opt.collection) {
          pending.push(
            fetchCollection(opt.collection).then(list => {
              shuffle(list).slice(0, maxResults * 2).forEach(p => addProduct(p, opt, 1));
            })
          );
        }
      });
    });

    if (pending.length) await Promise.all(pending);

    recommended = Array.from(byVariant.values())
      .sort((a, b) => (b.score - a.score) || (a.order - b.order))
      .slice(0, maxResults);

    renderWarnings(warnings);
    renderResults();
  }

  function renderWarnings(list) {
    if (!els.warnings) return;
    if (!list.length) { els.warnings.hidden = true; els.warnings.innerHTML = ''; return; }

    els.warnings.innerHTML = '';
    Array.from(new Set(list)).forEach(text => {
      const box = document.createElement('div');
      box.className = 'qz-warning';
      box.textContent = text;
      els.warnings.appendChild(box);
    });
    els.warnings.hidden = false;
  }

  function renderResults() {
    chosen.clear();
    els.results.innerHTML = '';

    if (!recommended.length) {
      els.empty.hidden = false;
      els.sticky.hidden = true;
      return;
    }
    els.empty.hidden = true;

    recommended.forEach(p => {
      chosen.add(p.variantId);

      const card = document.createElement('label');
      card.className = 'qz-card selected';

      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = true;
      cb.className = 'qz-card-check';
      cb.addEventListener('change', () => {
        cb.checked ? chosen.add(p.variantId) : chosen.delete(p.variantId);
        card.classList.toggle('selected', cb.checked);
        updateSticky();
      });

      const media = document.createElement('span');
      media.className = 'qz-card-media';
      if (p.image) {
        const img = document.createElement('img');
        img.src = p.image;
        img.srcset = p.image + ' 1x';
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        media.appendChild(img);
      }

      const body = document.createElement('span');
      body.className = 'qz-card-body';

      const vendor = document.createElement('span');
      vendor.className = 'qz-card-vendor';
      vendor.textContent = p.vendor || '';

      const title = document.createElement('a');
      title.className = 'qz-card-title';
      title.href = p.url;
      title.textContent = p.title;
      title.addEventListener('click', e => e.stopPropagation());

      const prices = document.createElement('span');
      prices.className = 'qz-card-prices';
      const now = document.createElement('strong');
      now.textContent = money(p.price);
      prices.appendChild(now);
      if (p.compareAt && p.compareAt > p.price) {
        const was = document.createElement('s');
        was.textContent = money(p.compareAt);
        prices.appendChild(was);
      }

      body.append(vendor, title, prices);

      if (p.reason) {
        const reason = document.createElement('span');
        reason.className = 'qz-card-reason';
        const strong = document.createElement('strong');
        strong.textContent = (config.reasonPrefix || 'Dlaczego:') + ' ';
        reason.append(strong, document.createTextNode(p.reason));
        body.appendChild(reason);
      }

      card.append(cb, media, body);
      els.results.appendChild(card);
    });

    updateSticky();
  }

  function updateSticky() {
    const items = recommended.filter(p => chosen.has(p.variantId));
    const empty = !items.length;

    if (els.sticky) els.sticky.hidden = empty;
    if (els.bulk)   els.bulk.hidden   = empty;
    if (empty) return;

    const total = items.reduce((sum, p) => sum + p.price, 0);
    const label = fill(labels.selected, items.length + ' ' + plural(items.length));
    const sum   = money(total);

    if (els.stickyCount) els.stickyCount.textContent = label;
    if (els.stickyTotal) els.stickyTotal.textContent = sum;
    if (els.bulkCount)   els.bulkCount.textContent   = label;
    if (els.bulkTotal)   els.bulkTotal.textContent   = sum;
  }

  /* ── Add the whole set to cart ──────────────────────────── */

  async function addSelected() {
    const items = recommended
      .filter(p => chosen.has(p.variantId))
      .map(p => ({ id: parseInt(p.variantId, 10), quantity: 1 }));

    if (!items.length) return;

    /* Przyciski są dwa — stan „Dodaję…” musi objąć oba, żeby podwójne
       kliknięcie nie wysłało zestawu drugi raz. */
    const buttons  = els.addButtons.filter(Boolean);
    const originals = buttons.map(b => b.textContent);
    const setBusy = busy => buttons.forEach((b, i) => {
      b.disabled = busy;
      b.textContent = busy ? (labels.adding || 'Dodaję…') : originals[i];
    });

    setBusy(true);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.error('[PH24 Quiz] Dodanie do koszyka nie powiodło się:', err.description || res.status);
        setBusy(false);
        return;
      }

      // Shopify has no storefront API for applying a code, so we use the
      // native /discount/<code> route — the same trick the cart drawer uses.
      if (config.useDiscount && config.discountCode) {
        const back = window.location.pathname + '?cart=open';
        window.location.href = '/discount/' + encodeURIComponent(config.discountCode) +
          '?redirect=' + encodeURIComponent(back);
        return;
      }

      setBusy(false);

      if (window.PH24 && window.PH24.refreshCartDrawer) {
        await window.PH24.refreshCartDrawer();
        window.PH24.openCartDrawer();
      } else {
        window.location.href = '/cart';
      }
    } catch (err) {
      console.error('[PH24 Quiz] Błąd dodawania do koszyka:', err);
      setBusy(false);
    }
  }

  /* ── Wiring ─────────────────────────────────────────────── */

  function startQuiz() {
    if (els.consent && !els.consent.checked) {
      els.consent.closest('.qz-consent').classList.add('attention');
      window.setTimeout(() => {
        const box = els.consent.closest('.qz-consent');
        if (box) box.classList.remove('attention');
      }, 900);
      return;
    }
    show('questions');
    renderStep();
  }

  els.start && els.start.addEventListener('click', startQuiz);
  els.next  && els.next.addEventListener('click', goNext);
  els.back  && els.back.addEventListener('click', goBack);
  els.addButtons.forEach(b => b.addEventListener('click', addSelected));
  els.restart && els.restart.addEventListener('click', () => {
    stepIndex = 0;
    answers.forEach(set => set.clear());
    recommended = [];
    chosen.clear();
    els.sticky.hidden = true;
    show('intro');
  });

  // Reopen the drawer after the /discount redirect brought us back.
  if (new URLSearchParams(window.location.search).get('cart') === 'open') {
    const url = new URL(window.location.href);
    url.searchParams.delete('cart');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    if (window.PH24 && window.PH24.openCartDrawer) window.PH24.openCartDrawer();
  }

  // A deep link skips the intro and lands straight on the first question.
  if (applyDeepLink()) {
    show('questions');
    renderStep();
  }
})();
